/**
 * filters navigator.languages to only include valid locale codes
 * locale codes are valid if they match one of the following formats:
 *
 * ab
 * ab-CD
 * ab-Cdef-GH
 * ab-123
 *
 * @returns string[] - array of valid locale codes
 */

export const getUserLanguages = (): string[] => {
  if (typeof navigator === 'undefined') return ['en'];

  const rawLanguages: unknown = (navigator as Navigator & { languages?: unknown })
    .languages;

  const languages: string[] = Array.isArray(rawLanguages)
    ? rawLanguages.filter((lang): lang is string => typeof lang === 'string')
    : typeof navigator.language === 'string'
      ? [navigator.language]
      : [];

  const validLanguages = languages
    .map(lang =>
      lang
        // locales sometimes include a "relative quality factor" in the format "en;q=0.9"
        // we need to strip that out first
        .replace(/;.*/, '')
        .match(/^[a-z]{2,3}(?:-[A-Z][a-z]{3})?(?:-[A-Z]{2}|-[0-9]{3})?$/)
    )
    .filter((lang): lang is RegExpMatchArray => Boolean(lang))
    .flat();

  return validLanguages.length ? validLanguages : ['en'];
};
